export default {"src":"/_next/static/image/public/images/ic_pom_upload_icon.a591f7c870156143436c36d64acbd5e9.svg","height":16,"width":15};